module.exports = __webpack_public_path__ + "img/1.94b445c3.jpg";